import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {ApiPartnerToken} from '../../../../../models/api-partner-token';

import {PartnerTokenService} from '../../../../../services/api-partner-token/partner-token.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {InputSwitchComponent} from '../../../../layout/input-switch/input-switch.component';
import {Partner} from '../../../../../models/partner/partner';

@Component({
  selector: 'app-partner-tools-token-form',
  imports: [
    ReactiveFormsModule,
    InputSwitchComponent
],
  templateUrl: './partner-tools-token-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-tools-token-form.component.scss'
})
export class PartnerToolsTokenFormComponent implements Dialog {
  loaded = false;
  partner: Partner | null = null;
  partnerToken: ApiPartnerToken | null = null;

  form = new FormGroup({
    label: new FormControl('', Validators.required),
    subid: new FormControl(''),
    preping: new FormControl(false),
    hideReactivationResponseCode: new FormControl(false),
  });

  constructor(
    private loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private partnerTokenService: PartnerTokenService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.partner = params.data.partner;

    if (params.data?.partnerToken) {
      this.loader.startLoading();
      this.partnerTokenService.findOneById(params.data.partnerToken.id).subscribe((partnerToken) => {
        this.partnerToken = partnerToken;

        this.form.patchValue({
          label: this.partnerToken.label,
          subid: this.partnerToken.subid,
          preping: this.partnerToken.preping,
          hideReactivationResponseCode: this.partnerToken.hideReactivationResponseCode
        });

        this.loaded = true;
        this.loader.stopLoading();
      });
    } else {
      this.loaded = true;
    }
  }

  isCreate(): boolean {
    return this.partnerToken === null;
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    const params: any = this.form.value;

    params.partnerId = this.partner?.id;

    this.loader.startLoading();

    if (this.partnerToken && this.partnerToken.id) {
      this.partnerTokenService.update(this.partnerToken.id, params).subscribe(() => {
        this.snackbar.success('Token has been updated');
        this.loader.stopLoading();
        this.dialog.closeDialog(params);
      });
    } else {
      this.partnerTokenService.create(params).subscribe(() => {
        this.snackbar.success('Token has been created');
        this.loader.stopLoading();
        this.dialog.closeDialog(params);
      });
    }
  }
}
